import { render, staticRenderFns } from "./commentCheck.vue?vue&type=template&id=47a04fb1"
import script from "./commentCheck.vue?vue&type=script&lang=ts"
export * from "./commentCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports